﻿import type { RedirectRequest, SilentRequest } from '@azure/msal-browser'
import * as msal from '@azure/msal-browser'
import { LogLevel } from '@azure/msal-browser'
import router from '@/router'


const msalConfig: msal.Configuration = {
    auth: {
        clientId: import.meta.env.VITE_MSAL_CLIENT_ID as string,
        authority: import.meta.env.VITE_MSAL_AUTHORITY as string,
        knownAuthorities: [import.meta.env.VITE_MSAL_KNOWN_AUTHORITIES as string],
        redirectUri: (window.location.origin + import.meta.env.VITE_MSAL_REDIRECT_PATH) as string,
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: false,

    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                if (containsPii) {
                    return
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message)
                        return
                    case LogLevel.Info:
                        console.info(message)
                        return
                    case LogLevel.Verbose:
                        console.debug(message)
                        return
                    case LogLevel.Warning:
                        console.warn(message)
                        return
                }
            },
            piiLoggingEnabled: false
        },
        windowHashTimeout: 60000,
        iframeHashTimeout: 6000,
        loadFrameTimeout: 0,
        asyncPopups: false
    }
}
const msalInstance = new msal.PublicClientApplication(msalConfig)

const loginRequest: RedirectRequest = {
    scopes: ['openid', import.meta.env.VITE_MSAL_SCOPE as string]
}

const tokenRequest: RedirectRequest | SilentRequest = {
    scopes: [import.meta.env.VITE_MSAL_SCOPE as string],
    forceRefresh: false
}


// Handle the redirect flows
msalInstance
    .handleRedirectPromise()
    .then((tokenResponse) => {
        // Handle redirect response
        //  router.push({ name: 'home' });
    })
    .finally(() => {
        // Handle redirect completion
    })
    .catch((error) => {
        // Handle redirect error
    });

export { loginRequest, msalInstance, tokenRequest }
